// @ts-strict-ignore
import { PrivilegeItem } from '@components/_membership/_privileges/Item';
import { Heading } from '@components/gassan-ui/Typography/Heading';
import { Text } from '@components/gassan-ui/Typography/Text';
import { parse } from '@config/theme';
import { Radio } from '@gassan-ui';
import { getServerSideTranslations } from '@lib/get-server-side-translations';
import { SingleItemResponse, getPrivilegeItem } from '@lib/kontent';
import { PrivilegeItem as PrivilegeItemPageModel } from '@lib/kontent/models/PrivilegeItem';
import { PageProps } from '@lib/types';
import { GetServerSideProps } from 'next';
import Head from 'next/head';
import { FC, useState } from 'react';
type PrivilegeItemPageProps = PageProps<{
  content: SingleItemResponse<PrivilegeItemPageModel>;
}>;
const PrivilegeItemPage: FC<PrivilegeItemPageProps> = ({
  data
}) => {
  const [demoVariant, setDemoVariant] = useState<'RESERVATION' | 'SALESORDER'>('RESERVATION');
  const {
    modular_content
  } = data.content;
  return <>
      <Head>
        <meta key="robots" name="robots" content="noindex,follow" />
        <meta key="googlebot" name="googlebot" content="noindex,follow" />
      </Head>
      <div className={parent}>
        <section className={container}>
          <Heading variant="h1" as="h1" className="mb-2">
            Privilege item preview
          </Heading>
          <Text variant="regular" className="mb-8 text-shade-500">
            <span style={{
            color: 'red'
          }}>Let op:</span> er wordt demo-data gebruikt op deze
            pagina. Er wordt geen privilege-data uit DAF gehaald, alleen content uit Kentico
          </Text>
          <div className={grid}>
            <PrivilegeItem elements={data.content.item.elements} isAvailable modularContent={modular_content} dafItem={getDemoVariant()} />
          </div>
          <div className={buttons}>
            <Text variant="regular" className="mb-0 mr-8 text-shade-500">
              Wijzig privilege demo actie:
            </Text>
            <Radio mb="0" name="sort" id="reservation" label="Reservation" checked={demoVariant === 'RESERVATION'} onChange={() => setDemoVariant('RESERVATION')} />
            <Radio mb="0" name="sort" id="salesOrder" label="Sales order" disabled checked={demoVariant === 'SALESORDER'} onChange={() => setDemoVariant('SALESORDER')} />
          </div>
        </section>
      </div>
    </>;
  function getDemoVariant() {
    if (demoVariant === 'RESERVATION') {
      return {
        privilege_nr: 7,
        description: 'Personal shopper',
        max_aantal: 1,
        beschikbaar: 1,
        artikel_nr: 0,
        privilege_action: 'RESERVATION'
      };
    }
    return {
      privilege_nr: 16,
      description: 'Recepit Babygem',
      max_aantal: 2,
      beschikbaar: 1,
      artikel_nr: 9979999,
      privilege_action: 'SALESORDER'
    };
  }
};
const buttons = parse({
  mt: '8',
  display: 'flex',
  alignItems: 'center'
});
const parent = parse({
  pt: '16'
});
const container = parse({
  mx: 'auto',
  my: '0'
}, "cambnu2");
const grid = parse({
  display: 'grid'
}, "g11uq54r");
export const getServerSideProps: GetServerSideProps = async ({
  locale,
  query
}) => {
  const lang = (query.lang as string);
  const id = (query.id as string);
  try {
    const content: SingleItemResponse<PrivilegeItemPageModel> = await getPrivilegeItem({
      language: lang,
      id
    });
    return {
      props: {
        data: {
          content,
          ...(await getServerSideTranslations(locale))
        }
      }
    };
  } catch (error) {
    return {
      notFound: true
    };
  }
};
export default PrivilegeItemPage;

require("./index.linaria.module.css!=!../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");